import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "global-container" }
const _hoisted_3 = { class: "options-container" }
const _hoisted_4 = { class: "contents-container" }
const _hoisted_5 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_6 = {
  key: 0,
  style: {
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100vw'
            }
}

import '@vueup/vue-quill/dist/vue-quill.snow.css'
import '@vueup/vue-quill/dist/vue-quill.bubble.css'
import HeaderComponent from '@/components/home/HeaderComponent.vue'
import ImageUploader from 'quill-image-uploader'

import { useAuthStore } from '@/stores/AuthStateStore'
import { storeToRefs } from 'pinia'
import { firestore as db, storage } from '@/main'
import { Project, ProjectRequest } from '@/types/Research'
import { updateDoc, addDoc, doc, getDocs, query, collection, orderBy, deleteDoc, getDoc } from 'firebase/firestore'
import { getDownloadURL, ref as storageRef, uploadBytes } from 'firebase/storage'
import { onMounted, ref, watch } from 'vue'
import { Delta, QuillEditor } from '@vueup/vue-quill'
import CommonProgress from '@/components/common/CommonProgress.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ResearchView',
  setup(__props) {

const { isSignedIn, isAdmin } = storeToRefs(useAuthStore())

const isLoading = ref(true)
const isUploading = ref(false)
const isEditMode = ref(false)
const selectedId = ref('')
const selectedDate = ref(new Date())
const showAddModal = ref(false)
const showResearchModal = ref(false)
const selectedOption = ref('Research')
const options = ref(['Research', 'Projects'])
const projectList = ref<Project[]>([])
const projectsQuery = query(collection(db, 'Projects'), orderBy('beginDate', 'desc'))
const newProjectModel = ref<ProjectRequest>(
  {
    agency: '',
    beginDate: `${new Date().getFullYear()}.${String(new Date().getMonth() + 1).padStart(2, '0')}.${String(new Date().getDate()).padStart(2, '0')}`,
    budget: '',
    budgetUnit: 'KRW',
    contents: '',
    endDate: `${new Date().getFullYear()}.${String(new Date().getMonth() + 1).padStart(2, '0')}.${String(new Date().getDate()).padStart(2, '0')}`
  }
)
const newResearchModel = ref<Delta|undefined>(undefined)
const researchContents = ref<Delta|undefined>(undefined)
const modules = {
  name: 'Imageuploader',
  module: ImageUploader,
  options: {
    upload: (file: File) => {
      isUploading.value = true

      return new Promise((resolve, reject) => {
        uploadBytes(storageRef(storage, `research/${file.name}`), file)
          .then((snapshot) => {
            getDownloadURL(snapshot.ref)
              .then((url) => {
                resolve(url)
              })
              .catch((e: Error) => {
                console.log(e.message)
                reject(e)
              })
              .finally(() => {
                isUploading.value = false
              })
          })
          .catch((e: Error) => {
            isUploading.value = false
            console.log(e.message)
            reject(e)
          })
      })
    }
  }
}
const showDatePicker = ref(false)
const datePickerType = ref<'begin' | 'end'>('begin')

function setDate () {
  const formattedDate = `${selectedDate.value.getFullYear()}.${String(selectedDate.value.getMonth() + 1).padStart(2, '0')}.${String(selectedDate.value.getDate()).padStart(2, '0')}`

  if (datePickerType.value === 'begin') {
    newProjectModel.value.beginDate = formattedDate
  } else {
    newProjectModel.value.endDate = formattedDate
  }

  showDatePicker.value = false
}

function updateResearch () {
  if (newResearchModel.value === undefined || newResearchModel.value.ops.length === 0) {
    alert('Please fill in all fields.')
    return
  }

  isUploading.value = true

  updateDoc(doc(db, 'Research', 'contents'), {
    contents: JSON.stringify(newResearchModel.value)
  })
    .then(() => {
      alert('Contents updated successfully.')
      researchContents.value = newResearchModel.value

      isEditMode.value = false
      selectedId.value = ''
      showAddModal.value = false
    })
    .catch((e: Error) => {
      console.log(e.message)
      alert(`An error occurred while updating the lecture: ${e.message}`)
    })
    .finally(() => {
      isUploading.value = false
    })
}

function uploadProject () {
  if (newProjectModel.value.agency === '' || newProjectModel.value.beginDate === '' || newProjectModel.value.endDate === '' || newProjectModel.value.budget === '' || newProjectModel.value.contents === '' || newProjectModel.value.budgetUnit === '') {
    alert('Please fill in all fields.')
    return
  }

  isUploading.value = true

  if (isEditMode.value && selectedId.value !== '') {
    updateDoc(doc(db, 'Projects', selectedId.value), {
      ...newProjectModel.value
    })
      .then(() => {
        alert('Project updated successfully.')
        const index = projectList.value.findIndex(p => p.id === selectedId.value)
        if (index !== -1) {
          projectList.value[index] = { id: selectedId.value, ...newProjectModel.value }
        }

        isEditMode.value = false
        selectedId.value = ''
        showAddModal.value = false
      })
      .catch((e: Error) => {
        console.log(e.message)
        alert(`An error occurred while updating the lecture: ${e.message}`)
      })
      .finally(() => {
        isUploading.value = false
      })
  } else {
    addDoc(collection(db, 'Projects'), {
      ...newProjectModel.value
    })
      .then((doc) => {
        alert('Project created successfully.')
        projectList.value.push({
          id: doc.id,
          ...newProjectModel.value
        } as Project)

        showAddModal.value = false
      })
      .catch((e: Error) => {
        console.log(e.message)
        alert(`An error occurred while creating the project: ${e.message}`)
      })
      .finally(() => {
        isUploading.value = false
      })
  }
}

function deleteProject (proj: Project) {
  if (confirm(`Are you sure you want to delete ${proj.contents} project?\nThis action cannot be undone.`)) {
    isLoading.value = true

    deleteDoc(doc(db, 'Projects', proj.id))
      .then(() => {
        alert('Project deleted successfully.')
        projectList.value = projectList.value.filter(p => p.id !== proj.id)
      })
      .catch((e: Error) => {
        console.log(e.message)
        alert(`An error occurred while deleting the project: ${e.message}`)
      })
      .finally(() => {
        isLoading.value = false
      })
  }
}

function getProjects () {
  isLoading.value = true
  getDocs(projectsQuery)
    .then((docs) => {
      projectList.value = docs.docs.map(doc => ({ id: doc.id, ...doc.data() })) as Project[]
    })
    .catch((e: Error) => {
      console.log(e.message)
    })
    .finally(() => {
      isLoading.value = false
    })
}

function getResearch () {
  getDoc(doc(db, 'Research', 'contents'))
    .then((doc) => {
      if (doc.exists()) {
        researchContents.value = new Delta(JSON.parse(doc.data().contents))
        newResearchModel.value = researchContents.value
      }
    })
    .catch((e: Error) => {
      console.log(e.message)
      alert(`An error occurred while updating the lecture: ${e.message}`)
    })
    .finally(() => {
      isLoading.value = false
      isEditMode.value = false
      selectedId.value = ''
      showAddModal.value = false
      showResearchModal.value = false
    })
}

watch(selectedOption, () => {
  if (selectedOption.value === 'Projects') {
    getProjects()
  } else {
    getResearch()
  }
})

watch(showAddModal, (newVal) => {
  if (!newVal) {
    isEditMode.value = false
    selectedId.value = ''
    newProjectModel.value = {
      agency: '',
      beginDate: `${new Date().getFullYear()}.${String(new Date().getMonth() + 1).padStart(2, '0')}.${String(new Date().getDate()).padStart(2, '0')}`,
      budget: '',
      budgetUnit: 'KRW',
      contents: '',
      endDate: `${new Date().getFullYear()}.${String(new Date().getMonth() + 1).padStart(2, '0')}.${String(new Date().getDate()).padStart(2, '0')}`
    }
  }
})

onMounted(() => {
  getResearch()
})


return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_card_contents = _resolveComponent("v-card-contents")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(HeaderComponent, {
              title: selectedOption.value,
              "trailing-icon": selectedOption.value === 'Research' ? 'fa-solid fa-edit' : 'fa-solid fa-add',
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (selectedOption.value === 'Research' ? showResearchModal.value = true : showAddModal.value = true))
            }, null, 8, ["title", "trailing-icon"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "ml-2",
                key: option
              }, [
                (selectedOption.value === option)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      "prepend-icon": "mdi-check",
                      variant: "tonal",
                      color: "primary",
                      class: "rounded-pill"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createBlock(_component_v_chip, {
                      key: 1,
                      onClick: ($event: any) => (selectedOption.value = option),
                      variant: "tonal",
                      class: "rounded-pill"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_4, [
            (isLoading.value)
              ? (_openBlock(), _createBlock(CommonProgress, { key: 0 }))
              : (selectedOption.value === 'Projects')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (projectList.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" }),
                          _cache[22] || (_cache[22] = _createTextVNode(" " + _toDisplayString('No projects found'), -1))
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectList.value, (project) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: project.id
                      }, [
                        _createVNode(_component_v_card, {
                          class: "mt-2 pa-2 card",
                          variant: "outlined"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { style: {"word-break":"break-word","white-space":"normal"} }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(project.contents), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_card_subtitle, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "fa-solid fa-calendar",
                                  class: "mr-1"
                                }),
                                _createTextVNode(" " + _toDisplayString(project.beginDate) + " - " + _toDisplayString(project.endDate), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_card_text, { class: "px-7" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { class: "project-row" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "fa-solid fa-building",
                                      class: "mr-1"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(project.agency), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, { class: "project-row" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "fa-solid fa-money-bill",
                                      class: "mr-1"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(project.budget.includes(',') ? project.budget : project.budget.replace(/\B(?=(\d{3})+(?!\d))/g, ",")) + " " + _toDisplayString(project.budgetUnit), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            (_unref(isSignedIn) && _unref(isAdmin))
                              ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      variant: "text",
                                      color: "primary",
                                      onClick: ($event: any) => {
                      {
                        isEditMode.value = true;
                        selectedId.value = project.id;
                        newProjectModel.value = {
                          agency: project.agency,
                          beginDate: project.beginDate,
                          budget: project.budget,
                          budgetUnit: project.budgetUnit,
                          contents: project.contents,
                          endDate: project.endDate
                        };
                        showAddModal.value = true;
                      }
                    }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "fa-solid fa-pen-to-square",
                                          class: "mr-1"
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_v_btn, {
                                      variant: "text",
                                      color: "red",
                                      onClick: ($event: any) => (deleteProject(project))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "fa-solid fa-trash",
                                          class: "mr-1"
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ]))
                : (selectedOption.value === 'Research')
                  ? (_openBlock(), _createBlock(_unref(QuillEditor), {
                      key: 2,
                      class: "mt-5",
                      content: researchContents.value,
                      "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((researchContents).value = $event)),
                      options: { readOnly: true, theme: 'bubble', modules: { toolbar: false } },
                      style: { maxWidth: '80vw' }
                    }, null, 8, ["content"]))
                  : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_v_dialog, {
          modelValue: showAddModal.value,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((showAddModal).value = $event)),
          class: "dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "pa-4 card" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "rounded-xl title-container" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { style: { alignItems: 'center', justifyContent: 'center', 'verticalAlign': 'middle' } }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(isEditMode.value ? 'Edit Project' : 'Add Project') + " ", 1),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          color: "red",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (showAddModal.value = false)),
                          disabled: isUploading.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_contents, { class: "card-contents" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      class: "mt-4",
                      modelValue: newProjectModel.value.contents,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newProjectModel.value.contents) = $event)),
                      label: "Contents",
                      variant: "outlined",
                      color: "primary",
                      "prepend-icon": "mdi-format-title",
                      "clear-icon": "mdi-close",
                      clearable: "",
                      "onClick:clear": _cache[4] || (_cache[4] = ($event: any) => (newProjectModel.value.contents = ''))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      class: "mt-4",
                      modelValue: newProjectModel.value.agency,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newProjectModel.value.agency) = $event)),
                      label: "Agency",
                      variant: "outlined",
                      color: "primary",
                      "prepend-icon": "mdi-office-building",
                      "clear-icon": "mdi-close",
                      clearable: "",
                      "onClick:clear": _cache[6] || (_cache[6] = ($event: any) => (newProjectModel.value.agency = ''))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_row, { class: "mt-4 budget-row" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: newProjectModel.value.budget,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newProjectModel.value.budget) = $event)),
                          label: "Budget",
                          variant: "outlined",
                          color: "primary",
                          type: "number",
                          "prepend-icon": "mdi-cash-multiple",
                          "clear-icon": "mdi-close",
                          clearable: "",
                          "onClick:clear": _cache[8] || (_cache[8] = ($event: any) => (newProjectModel.value.budget = '')),
                          class: "budget-field"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_text_field, {
                          class: "ml-2 budget-unit-field",
                          modelValue: newProjectModel.value.budgetUnit,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newProjectModel.value.budgetUnit) = $event)),
                          label: "Budget Unit",
                          variant: "outlined",
                          color: "primary",
                          "prepend-icon": "mdi-currency-usd",
                          "clear-icon": "mdi-close",
                          clearable: "",
                          "onClick:clear": _cache[10] || (_cache[10] = ($event: any) => (newProjectModel.value.budgetUnit = ''))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { class: "mt-2 pa-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          class: "mr-2",
                          modelValue: newProjectModel.value.beginDate,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((newProjectModel.value.beginDate) = $event)),
                          label: "Begin Date",
                          variant: "outlined",
                          color: "primary",
                          "prepend-icon": "mdi-calendar",
                          readonly: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_btn, {
                          onClick: _cache[12] || (_cache[12] = ($event: any) => {
                {
                  datePickerType.value = 'begin';
                  showDatePicker.value = true;
                }
                }),
                          variant: "text"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-calendar" })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { class: "mt-2 pa-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          class: "mr-2",
                          modelValue: newProjectModel.value.endDate,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((newProjectModel.value.endDate) = $event)),
                          label: "End Date",
                          variant: "outlined",
                          color: "primary",
                          "prepend-icon": "mdi-calendar",
                          readonly: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_btn, {
                          onClick: _cache[14] || (_cache[14] = ($event: any) => {
                {
                  datePickerType.value = 'end';
                  showDatePicker.value = true;
                }
                }),
                          variant: "text"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-calendar" })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_dialog, {
                      modelValue: showDatePicker.value,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((showDatePicker).value = $event)),
                      class: "dialog"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "pa-4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "rounded-xl date-picker-title-container" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { class: "date-picker-container" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(datePickerType.value === 'begin' ? 'Select Begin Date' : 'Select End Date') + " ", 1),
                                    _createVNode(_component_v_spacer),
                                    _createVNode(_component_v_btn, {
                                      variant: "text",
                                      color: "red",
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (showDatePicker.value = false))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_contents, { class: "my-5 row" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_date_picker, {
                                  modelValue: selectedDate.value,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((selectedDate).value = $event)),
                                  "show-adjacent-months": ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_actions, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  variant: "tonal",
                                  color: "primary",
                                  onClick: setDate
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-check" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    (isUploading.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          color: "primary"
                        }))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          variant: "tonal",
                          color: "primary",
                          onClick: uploadProject
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-check" })
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: showResearchModal.value,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((showResearchModal).value = $event)),
          class: "dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "pa-4 card" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "rounded-xl title-container" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "row" }, {
                      default: _withCtx(() => [
                        _cache[23] || (_cache[23] = _createTextVNode(_toDisplayString('Modify Research') + " ", -1)),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          color: "red",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (showResearchModal.value = false)),
                          disabled: isUploading.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1,
                      __: [23]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_contents, { class: "mt-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(QuillEditor), {
                      class: "editor",
                      content: newResearchModel.value,
                      "onUpdate:content": _cache[20] || (_cache[20] = ($event: any) => ((newResearchModel).value = $event)),
                      toolbar: "full",
                      modules: modules,
                      options: { theme: 'bubble' }
                    }, null, 8, ["content"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    (isUploading.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          color: "primary"
                        }))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          variant: "tonal",
                          color: "primary",
                          onClick: updateResearch
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-check" })
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})